import React from 'react';
import { CircleCheckBig } from 'lucide-react';
import { Button } from '../../atoms';
import { Header } from '../../organisms';

export const CertificateRequestStatus: React.FC = () => {
  return (
    <>
      <Header barTitle='Bescheinigung angefragt' />

      <div className='mx-auto my-8 flex max-w-lg flex-col items-center rounded-lg border border-gray-200 bg-gray-50 p-6 text-center shadow-sm sm:p-8'>
        <CircleCheckBig className='mb-4 h-16 w-16 text-primary' aria-hidden='true' />
        <h2 className='mb-2 text-2xl font-bold text-gray-800'>Anfrage erfolgreich übermittelt</h2>
        <p className='text-gray-600'>Wir haben Ihre Anfrage für eine Bescheinigung erhalten.</p>
        <p className='text-gray-600'>Wir werden uns in den nächsten Tagen bei Ihnen melden.</p>
        <Button
          className='mt-6 w-full sm:w-auto'
          onClick={() => {
            window.location.href = '/dashboard';
          }}
        >
          Zum Dashboard
        </Button>
      </div>
    </>
  );
};
